<div class="dialog-header">
  <div class="header-icon">
    <mat-icon>location_on</mat-icon>
  </div>
  <div class="header-text">
    <h2 style="margin: 0;">Mix Designs</h2>
    <span class="header-subtitle">
      {{ mixDesigns.length }} {{ mixDesigns.length === 1 ? 'result' : 'results' }}@if (locationLabel) {
      · {{ locationLabel }}
    }
  </span>
</div>
<button mat-icon-button class="close-button" aria-label="Close" (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
</div>

<mat-dialog-content class="dialog-content">
  @for (mixDesign of mixDesigns; track mixDesign) {
    <a
      class="mix-design-card"
      [routerLink]="['/mix-design/search']"
      [queryParams]="getQueryParams(mixDesign)"
      target="_blank"
      rel="noopener">
      <div class="card-body">
        <div class="card-heading">
          <span class="mix-id">{{ mixDesign.mixId }}</span>
          @if (mixDesign.mixReferenceId) {
            <span class="reference-badge">{{ mixDesign.mixReferenceId }}</span>
          }
        </div>
        <div class="card-detail">
          <mat-icon class="detail-icon">work_outline</mat-icon>
          <span [class.empty]="!mixDesign.projectName">{{ mixDesign.projectName || 'No project name' }}</span>
        </div>
        <div class="card-detail">
          <mat-icon class="detail-icon">business</mat-icon>
          <span [class.empty]="!mixDesign.companyName">{{ mixDesign.companyName || 'No company' }}</span>
        </div>
        <div class="card-detail">
          <mat-icon class="detail-icon">category</mat-icon>
          <span [class.empty]="!mixDesign.materialType">{{ mixDesign.materialType || 'No material type' }}</span>
        </div>
      </div>
      <mat-icon class="open-icon">open_in_new</mat-icon>
    </a>
  }
</mat-dialog-content>
